import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import Catalog from "./Classes/Catalog";
import Cart from "./Classes/Cart";
import FilterList from "./Classes/FilterList";
import Node from "./Classes/Node";
import Config from "./Classes/Config";
import Dealer from "./Classes/Dealer";
import _ from "lodash";
import router from "./router";
import PersonAddItem from "./Classes/PersonAddItem";
import PersonItemQuantity from "./Classes/PersonItemQuantity";
import PersonItemNotes from "./Classes/PersonItemNotes";
import PersonDeleteItem from "./Classes/PersonDeleteItem";
import PersonItemOptionValue from "./Classes/PersonItemOptionValue";
import PersonClearCart from "./Classes/PersonClearCart";
import buildTimestamp from "raw-loader!../build-timestamp.txt";

//Setup Axios
var baseUrl = `${window.location.protocol}//${window.location.hostname}/`;
axios.defaults.baseURL = baseUrl;
var token = localStorage.getItem("token");
if (token) {
  axios.defaults.headers.common["X-Amptab-Auth-Ticket"] = token;
}

axios.defaults.headers.common["X-Spa-Build-Timestamp"] = buildTimestamp;

//https://github.com/axios/axios#interceptors
axios.interceptors.request.use(function (config) {
  return config;
}, function (error) {
  return Promise.reject(error);
});

// Add a response interceptor
axios.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  console.log("Response Error Interceptor");
  console.log("error", error);
  console.log("error.response", error.response);

  if (error.response.status == 401) {
    store.dispatch("logout");
    router.push("/Login");
  }

  var errorMessage = `${error.response.status} / ${error.response.data}`;
  var theError = new Error(errorMessage);
  return Promise.reject(theError);
});

Vue.use(Vuex);

var store = new Vuex.Store({
  state: {
    syncing: true,
    secondsSinceLastSync: 0,
    loginConfig: null,
    manufacturerId: "",
    token: localStorage.getItem("token") || "",
    catalog: null,
    config: null,
    search: "",
    path: [],
    tree: {},
    columnIdToValues: {},
    columnIdToValuesToggle: false,
    page: 1,
    groupsPerPage: 48,
    dealer: {},
    slideshow: {},
    zoomImageDialog: false,
    zoomImageUrl: "",
    station: [],
    train: {
      transit: false,
      passengers: []
    },
    serverCart: {},
    errorCount: 0
  },
  mutations: {
    incrementErrorCount(state) {
      state.errorCount = state.errorCount + 1;
    },
    resetErrorCount(state) {
      state.errorCount = 0;
    },
    setSecondsSinceLastSync(state, value) {
      state.secondsSinceLastSync = value;
    },
    setSyncing(state, value) {
      state.syncing = value;
    },
    setLoginConfig(state, payload) {
      state.loginConfig = payload;
    },
    setManufacturerId(state, payload) {
      state.manufacturerId = payload;
    },
    setToken: function (state, payload) {
      state.token = payload;
    },
    setCatalog: function (state, payload) {
      state.catalog = payload;
    },
    setConfig: function (state, payload) {
      state.config = payload;
    },
    setFilters: function (state, payload) {
      state.filters = payload;
    },
    setSearch: function (state, payload) {
      state.search = payload;
      state.page = 1;
    },
    setPage: function (state, payload) {
      state.page = payload;
    },
    setDealer: function (state, payload) {
      state.dealer = payload;
    },
    setTree: function (state, payload) {
      state.tree = payload;
    },
    addToPath: function (state, payload) {
      state.path.push(payload);
    },
    clearPath: function (state) {
      state.path = [];
    },
    setPath: function (state, index) {
      state.path = state.path.slice(0, index + 1);
    },
    setColumnIdToValues: function (state, payload) {
      state.columnIdToValuesToggle = !state.columnIdToValuesToggle;
      state.columnIdToValues[payload.column.id] = payload.values;
    },
    clearColumnIdToValues: function (state) {
      state.columnIdToValues = {};
    },
    setSlideshow: function (state, payload) {
      state.slideshow = payload
    },
    zoomImage: function (state, image) {
      state.zoomImageDialog = true;
      state.zoomImageUrl = image.largeUrl;
    },
    setZoomImageDialog: function (state, payload) {
      state.zoomImageDialog = false;
    },
    addToStation: function (state, payload) {
      state.station.push(payload);
    },
    setServerCart: function (state, payload) {
      state.serverCart = payload;
    },
  },
  getters: {
    currentNode: function (state) {
      var node = state.path.reduce((node, value) => {
        return node.next[value];
      }, state.tree);

      return node;
    },
    filters: function (state, getters) {
      var toggle = state.columnIdToValuesToggle; //Hack to trigger getter to fire
      var columnIdToValuesLowerCase = _.mapValues(state.columnIdToValues, value => value.map(x => x.toLowerCase()));
      return new FilterList(state.config.filterColumns, getters.searchedGroups, columnIdToValuesLowerCase).filters;
    },
    searchedGroups: function (state, getters) {
      if (!state.search) {
        return getters.currentNode.groups;
      }

      var searchLowerCase = state.search.toLowerCase();
      var searchColumns = state.catalog.columns.filter(column => column.searchWeight > 0);
      var groupWeights = getters.currentNode.groups.map(group => ({ group: group, searchWeight: group.searchWeight(searchColumns, searchLowerCase) }));
      var a = groupWeights.filter(a => a.searchWeight > 0);
      var b = a.sort((a, b) => b.searchWeight - a.searchWeight);
      var c = b.map(a => a.group);
      return c;
    },
    filteredGroups: function (state, getters) {
      var toggle = state.columnIdToValuesToggle; //Hack to trigger getter to fire

      var filterColumnIds = Object.keys(state.columnIdToValues);
      var columnIdToValuesLowerCase = _.mapValues(state.columnIdToValues, value => value.map(x => x.toLowerCase()));

      return filterColumnIds.length <= 0
        ? getters.searchedGroups
        : getters.searchedGroups.filter(group => group.filter(columnIdToValuesLowerCase))
    },
    theGroups: function (state, getters) {
      var start = (state.page - 1) * state.groupsPerPage;
      var end = state.page * state.groupsPerPage;
      return getters.filteredGroups.slice(start, end);
    },
    allPeople: function (state) {
      return _.union(state.train.passengers, state.station);
    },
    clientCart(state, getters) {
      var imageByNameLowerCase = _.keyBy(state.catalog.images, image => image.name.toLowerCase());
      var r = new Cart(state.serverCart, getters.allPeople, state.catalog.products, imageByNameLowerCase);
      return r;
    }
  },
  actions: {
    login: async function (context, payload) {
      try {
        var tokenUrl = "/Account/ApiSignin";
        var tokenData = {
          signinEmail: payload.email,
          password: payload.password
        };
        var tokenResponse = await axios.post(tokenUrl, tokenData);
        if (tokenResponse.data.result != "success") {
          throw tokenResponse.data.result;
        }
        var token = tokenResponse.data.auth_ticket;
        context.commit("setToken", token);
        localStorage.setItem("token", token);
        axios.defaults.headers.common["X-Amptab-Auth-Ticket"] = token;

        var manufacturersUrl = "/PersonalDashboard/ApiGetUserManifest";
        var manufacturersResponse = await axios.get(manufacturersUrl);
        var manufacturers = manufacturersResponse.data.manufacturers;
        var hasAccess = manufacturers.some(manufacturer => manufacturer.manufacturer_id == this.state.manufacturerId);
        if (!hasAccess) {
          throw "Not authorized to access database";
        }
      }
      catch (error) {
        context.dispatch("logout");
        throw error;
      }
    },
    logout: function (context) {
      context.commit("setToken", "");
      localStorage.removeItem("token");
      delete axios.defaults.headers.common["X-Amptab-Auth-Ticket"];
    },
    getLoginConfig: async function (context) {
      try {
        var url = `/Manufacturer/${context.state.manufacturerId}/ApiGetAvenueLoginConfig`;
        var response = await axios.get(url);
        context.commit("setLoginConfig", response.data);
      }
      catch (error) {
        throw error;
      }
    },
    sync: async function (context, syncType) {
      try {
        context.commit("setSyncing", true);
        var deepDataUrl = `/Manufacturer/${context.state.manufacturerId}/ApiGetAvenueData`;
        var cartUrl = `/api/spa/manufacturer/${context.state.manufacturerId}/preposals/objectId`;
        var deepDataResponse = await axios.get(deepDataUrl, {
          params: {
            syncType: syncType
          }
        });

        if (deepDataResponse.data.spa_dto_force_reload_client && context.getters.allPeople.length == 0) {
          console.log("Force Reload");
          window.location.reload();
        }

        var cartResponse = await axios.get(cartUrl, {
          params: {
            forceFirstPreposal: true
          }
        });

        var shortNames = deepDataResponse.data.spa_dto_short_names;

        console.log("Short Names", shortNames);

        var catalog = new Catalog(deepDataResponse.data, shortNames);
        var columnById = _.keyBy(catalog.columns, column => column.id);
        var groupByPageNumber = _.keyBy(catalog.groups, group => group.pageNumber);
        var config = new Config(deepDataResponse.data.spa_dto_avenue_config, columnById);
        context.commit("setCatalog", Object.freeze(catalog));
        context.commit("setDealer", Object.freeze(new Dealer(deepDataResponse.data.spa_dto_dealer, columnById)));
        context.commit("setConfig", Object.freeze(config));
        var pathColumns = config.tileColumns.slice(0, config.tileColumns.length);
        pathColumns.unshift(null);
        var imageByNameLowerCase = _.keyBy(catalog.images, image => image.name.toLowerCase());
        var tree = new Node(deepDataResponse.data.spa_dto_tile_tree, columnById, groupByPageNumber, imageByNameLowerCase);

        context.commit("setTree", Object.freeze(tree));
        context.commit("clearPath");

        var theSlideshow = deepDataResponse.data.spa_dto_presentation;
        context.commit("setSlideshow", Object.freeze(theSlideshow));

        context.commit("setSecondsSinceLastSync", 0);

        context.commit("setServerCart", cartResponse.data);
      }
      catch (error) {
        throw error;
      }
      finally {
        context.commit("setSyncing", false);
      }
    },
    placeOrder: async function (context, payload) {
      try {
        var url = `/api/spa/manufacturer/${context.state.manufacturerId}/preposals/objectId/order/place`;
        var data = {
          objectId: context.getters.clientCart.id,
          commitmentOnly: payload.commitmentOnly,
          retailQuote: payload.retailQuote,
          quoteForceClear: true
        };
        var response = await axios.post(url, data);

        context.commit("setServerCart", response.data.server_cart);
        if (response.data.AMP_Api_Result != "AAR_Success") {
          throw "Failed to place order";
        }

        return response.data.order_id;
      }
      catch (error) {
        throw error;
      }
    },
    allAboard: async function (context) {
      //Check if the train is at the station
      if (context.state.train.transit) {
        return;
      }

      try {
        //Move people from station to train
        while (context.state.station.length > 0) {
          context.state.train.passengers.push(context.state.station.shift());
        }

        //Send train to server
        context.state.train.transit = true;

        var url = `/api/spa/manufacturer/${context.state.manufacturerId}/station`;
        var data = {
          passengerDtos: context.state.train.passengers.map(person => person.toDto())
        };

        var response = await axios.post(url, data);

        //Server responds with a list of actions for spa to perform
        response.data.return_passenger_dtos.forEach(passenger_dto => {
          if (passenger_dto.type == "update-preposal") {
            context.commit("setServerCart", passenger_dto.preposal_dto);
          }
        });

        //Train dropped off passengers to server and comes back with updated cart
        context.state.train.passengers = [];
        context.commit("resetErrorCount");
      }
      catch (error) {
        //Train comes back with passengers
        context.commit("incrementErrorCount");
        throw error;
      }
      finally {
        //Train arrives back at station
        var cooldown = context.state.errorCount * 5000;
        var cooldown2 = Math.min(cooldown, 60000);
        await new Promise(resolve => setTimeout(resolve, cooldown2));
        context.state.train.transit = false;
        if (context.state.train.passengers.length > 0 || context.state.station.length > 0) {
          context.dispatch("allAboard");
        }
      }
    },
    addToStation(context, person) {
      context.commit("addToStation", person);
      context.dispatch("allAboard");
    },
    setItemQuantity2: function (context, payload) {
      var person = new PersonItemQuantity(context.getters.clientCart.id, payload.item.id, payload.quantity);
      context.dispatch("addToStation", person);
    },
    setItemNotes2: function (context, payload) {
      var person = new PersonItemNotes(context.getters.clientCart.id, payload.item.id, payload.notes);
      context.dispatch("addToStation", person);
    },
    addItem2: function (context, payload) {
      var person = new PersonAddItem(context.getters.clientCart.id, payload.product.sku, payload.quantity, payload.group.slideshow.presentation_dto_slideshow_digest, payload.group.pageDigest);
      context.dispatch("addToStation", person);

      return person.itemId;
    },
    deleteItem2: function (context, item) {
      var person = new PersonDeleteItem(context.getters.clientCart.id, item.id);
      context.dispatch("addToStation", person);
    },
    setItemOptionValue2: async function (context, payload) {
      var person = new PersonItemOptionValue(context.getters.clientCart.id, payload.item.id, payload.option.Id, payload.value.Id);
      context.dispatch("addToStation", person);
    },
    clearCart2: function (context) {
      var person = new PersonClearCart(context.getters.clientCart.id);
      context.dispatch("addToStation", person);
    }
  }
});

export default store;
